// src/pages/FAQ/faqData.js

export const faqItems = [
  {
    question: "What is PathoTrack?",
    answer: "PathoTrack is a secure web portal designed to enable genomic analysis pathogens, including CROs, Candida auris, and SARS-CoV-2.",
  },
  {
    question: "How do I access the analysis pipelines?",
    answer: `You can access the pipelines by logging in and navigating to the Dashboard section. 
    Ensure you have updated the data to BaseSpace and updated the BaseSpace token on the Profile page. 
    The instruction to upload the data and get the BaseSpace token are available <a href="/tutorial" target="_blank" rel="noopener noreferrer">here</a>.`,
  },
  // Add more Q&A here
];